module.exports = __webpack_public_path__ + "files/d869bc477229a8a4c368ed18fdbc9de9.svg";